// extracted by mini-css-extract-plugin
export default {"ShieldIcon":"BranchProtectionShield-module__ShieldIcon--y2aiB"};